import { all, takeLatest, put } from 'redux-saga/effects';

import {
  types,
  sendGTMEventError,
  sendGTMEventSuccess,
} from '@blueberry/redux/googleTagManager';
import { actions as errorActions } from '@blueberry/redux/error';

export function* sendGTMEvent(action) {
  const { eventName, data = {} } = action.payload;
  try {
    const event = {
      event: eventName,
      ...data,
    };

    const dataLayer = window.dataLayer || [];
    // Before sending new event, we need to make
    // sure that the fields sent are clear
    // as dataLayer appends the data
    // to the previous data
    // please look at https://www.lunametrics.com/blog/2016/03/21/removing-values-in-the-datalayer/
    const dataCopy = { ...data };
    Object.keys(dataCopy).forEach(key => {
      dataCopy[key] = undefined;
    });
    dataLayer.push({
      event: undefined,
      ...dataCopy,
    });
    dataLayer.push(event);
    yield put(sendGTMEventSuccess());
  } catch (err) {
    yield put(sendGTMEventError(err.message));
    yield put(errorActions.sendError(err));
  }
}

export default function*() {
  yield all([takeLatest(types.SEND_GTM_EVENT, sendGTMEvent)]);
}



// WEBPACK FOOTER //
// ./app/sagas/googleTagManager.js